import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Tile from 'src/components/Tile/Tile';
import TileActionsRemove from 'src/components/Tile/TileActionsRemove';
import TileActionsToggle from 'src/components/Tile/TileActionsToggle';


class Offer extends PureComponent {
  toggle = () => {
    const { toggleFavourite, isFavourite, id } = this.props;

    toggleFavourite(id, isFavourite);
  };

  remove = () => {
    const { remove, id } = this.props;

    remove(id);
  };

  render() {
    const { toggle } = this;
    const {
      id,
      jobTitle,
      company,
      logo,
      jobLink,
      location,
      isFavourite,
      remove,
      isSuperOffer,
      isOneClickApply
    } = this.props;

    return (
      <Tile
        company={ company }
        id={ id }
        isOneClickApply={ isOneClickApply }
        isSuperOffer={ isSuperOffer }
        job={ jobTitle }
        jobLink={ jobLink }
        location={ location }
        logo={ logo }
      >
        { remove && <TileActionsRemove remove={ this.remove } /> }
        <TileActionsToggle isFavourite={ isFavourite } toggleFavourite={ toggle } />
      </Tile>
    );
  }
}

Offer.propTypes = {
  company: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  isFavourite: PropTypes.bool.isRequired,
  isOneClickApply: PropTypes.bool.isRequired,
  isSuperOffer: PropTypes.bool.isRequired,
  jobLink: PropTypes.string.isRequired,
  jobTitle: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  remove: PropTypes.func,
  toggleFavourite: PropTypes.func.isRequired
};

Offer.defaultProps = {
  remove: null
};

export default Offer;
